import React from 'react';

export function AlertBox({className, children}: {className?: string, children: React.ReactNode}) {
  return (
    <div className={`tw-flex tw-content-start tw-items-center tw-gap-3 tw-p-5 tw-border tw-border-solid tw-border-gray-200 sa-bg-grey1 ${className}`}>
      <div><i className="picon picon-action" /></div>
      <div className="tw-text-base sa-text-blue">{ children }</div>
    </div>
  )
}